import { render, staticRenderFns } from "./LongResponse.vue?vue&type=template&id=5d584641&"
import script from "./LongResponse.vue?vue&type=script&lang=js&"
export * from "./LongResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports